<template>
  <div>
    <ul class="ul-li">
      <li @click="turnTo('/My/CompanyAuthen')">
        <img src="/static/images/me/qylogo.png">
        <p>企业认证</p>
      </li>
      <li @click="turnTo('/My/EgQualifications')" v-if='canShow == "True"'>
        <img src="/static/images/me/yglogo.png">
        <p>渠道认证</p>
      </li>
      <!--      <li @click="turnTo('/My/CompanyQualificationsInfo',true)">-->
      <!--        <img src="/static/images/HomeTH/comzz.png">-->
      <!--        <p>企业资质认证</p>-->
      <!--      </li>-->
      <!--      <li @click="turnTo('/My/CompanyQualificationsInfo',false)">-->
      <!--        <img src="/static/images/HomeTH/ygzz.png">-->
      <!--        <p>易购资质认证</p>-->
      <!--      </li>-->
          </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      canShow:true,
      url: {
        GetCustomAuthType: SZH.assets.api + '/Custom/GetCustomAuthType',
        GetSystemConfigure: SZH.assets.api + '/Market/GetSystemConfigure',//2021/12/24 新需求
      }
    }
  },
  methods: {
    turnTo(url, v) {
      this.$router.push({
        path: url,
        query: {
          iscom: v
        }
      })
    },
    GetCustomAuthType() {
      let self = this
      self.$http.post(self.url.GetCustomAuthType, {}).then(result => {
        if (result.state == true) {
          if(result.data != -1){
            this.$router.push({
              path: '/My/userInfo',
            })
          }else{
            self.GetSystemConfigure()
          }
        }
      })
    },
    GetSystemConfigure(){
      let self = this
      self.$http.post(self.url.GetSystemConfigure,{
        keyValue:"CustomAuthDisplay"
      }).then(result=>{
        if(result.state == 1){
          self.canShow = result.data
        }else{
          self.canShow = false
        }
      })
    }
  },
  computed: {},
  components: {},
  mounted() {
    this.GetCustomAuthType()
  }
}
</script>

<style scoped>
.ul-li li {
  text-align: center;
  display: inline-block;
  margin-left: 50px;
  cursor: pointer;
}

.ul-li li img {
  width: 46px;
}

.ul-li li:first-child {
  margin-left: 20px;
}

.ul-li li p {
  font-size: 14px;
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/Me/myMember/myMember.vue